export default "__VITE_ASSET__abb47310__"